module.exports = __webpack_public_path__ + "assets/img/c3a6ee5074ee85cc6330acfa8032b1a9.svg";